var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhnIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#155C8F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7711 10.439L16.8477 10.095C17.8565 9.77263 18.9343 10.2936 19.3664 11.3123L20.2261 13.3397C20.6008 14.2231 20.3929 15.262 19.7121 15.9081L17.8178 17.7062C17.9347 18.7816 18.2962 19.8406 18.9023 20.8832C19.5085 21.9257 20.2655 22.7905 21.1734 23.4776L23.4486 22.7189C24.311 22.4313 25.2502 22.7618 25.7792 23.539L27.0115 25.3495C27.6265 26.2529 27.5159 27.4993 26.7528 28.2653L25.9351 29.0862C25.1212 29.9033 23.9587 30.1997 22.8833 29.8643C20.3444 29.0723 18.0101 26.7211 15.8803 22.8107C13.7475 18.8945 12.9947 15.5719 13.6221 12.8429C13.8861 11.6946 14.7036 10.7801 15.7711 10.439Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhnIcon);
export default __webpack_public_path__ + "static/media/PhnIcon.c2fc1c382ff0fb3ddbf2f17e14841ef6.svg";
export { ForwardRef as ReactComponent };